import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import "../common/common.css";
import "./loginLanding.css";
import { authApiEndpoint } from "../../utils/env";

const CONFIRM_ENDPOINT = authApiEndpoint("/api/ApplicationUser/ConfirmEmail");

export default function ConfirmEmail() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("pending");
  const [message, setMessage] = useState("Confirming your email...");

  useEffect(() => {
    const uid = searchParams.get("uid");
    const token = searchParams.get("token");

    if (!uid || !token) {
      setStatus("error");
      setMessage("Invalid confirmation link.");
      return;
    }

    const confirm = async () => {
      try {
        const res = await fetch(CONFIRM_ENDPOINT, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ userId: uid, token }),
        });

        if (!res.ok) {
          let msg = "Unable to confirm email.";
          try {
            const data = await res.json();
            if (data?.message) msg = data.message;
          } catch {
            /* ignore */
          }
          throw new Error(msg);
        }

        setStatus("success");
        setMessage("Your email has been confirmed. You can now sign in.");
      } catch (err) {
        setStatus("error");
        setMessage(err.message || "Unable to confirm email.");
      }
    };

    confirm();
  }, [searchParams]);

  return (
    <div className="landing-root">
      <div className="landing-hero">
        <div className="hero-top">
          <div className="brand">
            <img
              src="/brand-logo.svg"
              alt="DIXI Vault"
              className="brand-logo"
            />
            <span className="brand-name">DIXI Vault</span>
          </div>
        </div>

        <div className="hero-content">
          <div className="hero-copy">
            <div className="eyebrow">Email verification</div>
            <h1>Confirming your email</h1>
            <p>{message}</p>
            {status === "success" && (
              <button
                className="cta"
                type="button"
                onClick={() => navigate("/login")}
              >
                Go to sign in
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
